import { translate } from "app/filters/i18nFilter";
import type { ContactDetail } from "app/pages/sales-intelligence/sub-modules/contacts-search/types/enums";

import type { TranslatedOption } from "../../../models/ContactDetailsFilter/ContactDetailsFilter";

import { TRANSLATION_PREFIX } from "./const";

export const mapToTranslatedOptions = (
    options: readonly ContactDetail[],
    translationType: "chip" | "checkbox",
): TranslatedOption[] => {
    return options.map(
        (rawOption: ContactDetail): TranslatedOption => ({
            label: translate(`${TRANSLATION_PREFIX}.${translationType}.${rawOption}`),
            value: rawOption,
        }),
    );
};
